import toTitleCase from "@hooks/toTitleCase";

/**
 * Humanize schema/field keys for display labels.
 * Handles snake_case, kebab-case, and camelCase (e.g. leadTime → Lead Time).
 */
export default function parseByDelimiter(string) {
  if (!string) return undefined;
  try {
    const spaced = String(string)
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return toTitleCase(spaced);
  } catch (e) {
    return string;
  }
}
